import React from "react"
import { Tabs, TabList, Tab, Text, TabPanels, TabIndicator, TabPanel, Box } from "@chakra-ui/react"
import MenTab from "../products/MenTab"
import WomenTab from "../products/WomenTab"
import KidsTab from "../products/KidsTab"

const ProductsTab: React.FC = () => {
  return (
    <Tabs>
      <TabList color='gray.500'>
        <Tab _selected={{ color: '#37A75B' }}>
          <Text fontSize='md' fontWeight='semibold'>
            Men
          </Text>
        </Tab>

        <Tab _selected={{ color: '#37A75B' }}>
          <Text fontSize='md' fontWeight='semibold'>
            Women
          </Text>
        </Tab>

        <Tab _selected={{ color: '#37A75B' }}>
          <Text fontSize='md' fontWeight='semibold'>
            Kids
          </Text>
        </Tab>
      </TabList>

      <TabIndicator
        mt="-1.5px"
        height="2px"
        bg="#37A75B"
        borderRadius="1px"
      />

      <TabPanels>
        <TabPanel p={0}>
          <Box mt='5'>
            <MenTab />
          </Box>
        </TabPanel>

        <TabPanel p={0}>
          <Box mt='5'>
            <WomenTab />
          </Box>
        </TabPanel>

        <TabPanel p={0}>
          <Box mt='5'>
            <KidsTab />
          </Box>
        </TabPanel>
      </TabPanels>    
    </Tabs>
  )
}

export default ProductsTab